import { render } from "./EmojiPicker.vue?vue&type=template&id=55b8dd1d&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"

import "./EmojiPicker.vue?vue&type=style&index=0&id=55b8dd1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b8dd1d"]])

export default __exports__